import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import Breadcrums from "../../../common/breadcrumbs";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import CustomCkeditor from "../../../common/customeditor";
import { Tooltip, Whisper } from "rsuite";
import Loader from "../../../common/loader";
import { AboutUsDetails, AddAboutUs } from "../../../services/aboutUs";

const AboutUsAdd = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [previewImageMain, setPreviewImageMain] = useState("");
    const [previewimage2, setPreviewImage2] = useState("");
    const [previewImages, setPreviewImages] = useState([]);
    const [defaultData, setDefaultData] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard/1" },
        { title: t("Add About Us"), url: "" },
    ];

    useEffect(() => {
        AboutUsDetails()
            .then((response) => {
                setDefaultData(response?.data);
                setPreviewImageMain(response?.data?.main_image);
                response?.data?.option?.map((opt) => setPreviewImages((prev) => [...prev, opt.option_image]));
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);

    console.log("defaultData-->", defaultData);

    const validationSchema = Yup.object().shape({
        question_title: Yup.string().trim().max(100, "max_length_error").required("Option is required"),
        question_description: Yup.string().trim().max(500, "max_length_error"),
        question_type: Yup.string().trim().max(100, "Cannot exceed 100 words").required("Question type is required"),
        option: Yup.array()
            .min(1, "At least one option is required")
            .of(
                Yup.object({
                    option_slug: Yup.string().min(1, "Option slug cannot be empty").required("Option slug is required"),
                    option_value: Yup.string().min(1, "Option value cannot be empty").required("Option value is required"),
                })
            )
            .required("Option array is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            main_title: defaultData && defaultData.main_title ? defaultData.main_title : "",
            main_content: defaultData && defaultData.main_content ? defaultData.main_content : "",
            main_image: defaultData && defaultData.main_image ? defaultData.main_image : "",
            // option: [
            //   {
            //     option_title:  "",
            //     option_content: "",
            //     option_image: "",
            //   }
            // ]
            option:
                defaultData && defaultData.option && defaultData.option.length > 0
                    ? defaultData.option.map((opt) => ({
                          option_title: opt.option_title,
                          option_content: opt.option_content,
                          option_image: opt.option_image,
                      }))
                    : [
                          {
                              option_title: "",
                              option_content: "",
                              option_image: "",
                          },
                      ],
        },
        validateOnBlur: false,
        // validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("main_title", values.main_title);
            formData.append("main_content", values.main_content);
            formData.append("main_image", values.main_image);
            formData.append("option", JSON.stringify(formik.values?.option));

            values.option.forEach((option, index) => {
                formData.append("image_list", option.option_image);
                // formData.append(`option[${index}][option_title]`, option.option_title);
                // formData.append(`option[${index}][option_content]`, option.option_content);

                // if (option.option_image) {
                //   formData.append(`option[${index}][option_image]`, option.option_image);
                // }
            });
            //   formData.append('option', JSON.stringify(values.option));

            AddAboutUs(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        // resetForm({ values: "" });
                        // navigate(`/admin/cms/about-us`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setSubmitted(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    const handleAddOption = () => {
        formik.setFieldValue("option", [...formik.values.option, { option_title: "", option_content: "", option_image: "" }]);

        setPreviewImages([...previewImages, null]);
    };

    const handleRemoveOption = (index) => {
        const newOptions = formik.values.option.filter((_, i) => i !== index);
        formik.setFieldValue("option", newOptions);

        const newPreviewImages = [...previewImages];
        newPreviewImages.splice(index, 1);
        setPreviewImages(newPreviewImages);
    };

    const handleImageChange = (event, index) => {
        const file = event.target.files[0];

        if (file) {
            formik.setFieldValue(`option[${index}].option_image`, file);
            const newPreviewImages = [...previewImages];
            newPreviewImages[index] = URL.createObjectURL(file);
            setPreviewImages(newPreviewImages);
        } else {
            formik.setFieldValue(`option[${index}].option_image`, null);
            const newPreviewImages = [...previewImages];
            newPreviewImages[index] = null;
            setPreviewImages(newPreviewImages);
        }
    };

    console.log("value--->", formik.values);
    console.log("errors--->", formik.errors);
    console.log("previewImages--->", previewImages);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <form onSubmit={formik.handleSubmit}>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-md-12 animation_fade">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div>
                                        <h6 className="main-content-label mb-3">{t("About Us")}</h6>
                                    </div>
                                    <div className="row row-sm">
                                        <h3>Section 1</h3>
                                        <div className="col-md-6 text-center form-group">
                                            <label htmlFor="main_title" className="text-left d-flex">
                                                Main Title:
                                                <span className="requirestar">*</span>{" "}
                                            </label>
                                            <input
                                                name="main_title"
                                                id="main_title"
                                                type="text"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.main_title}
                                                className="form-control"
                                                placeholder="Main Title"
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="main_title" form={formik} />
                                            </span>
                                        </div>

                                        <div className="col-lg-12 text-center form-group">
                                            <label htmlFor="main_content" className="text-left d-flex">
                                                Main content:<span className="requirestar">*</span>
                                            </label>
                                            <CustomCkeditor
                                                fieldname={"main_content"}
                                                setFieldValue={formik.setFieldValue}
                                                value={formik.values.main_content}
                                                setFieldTouched={formik.setFieldTouched}
                                            />
                                            <span className="text-danger d-flex text-left">{formik.errors.main_content && formik.touched.main_content && formik.errors.main_content}</span>
                                        </div>

                                        <div className="col-lg-6 text-center form-group">
                                            <label htmlFor="main_image" className="text-left d-flex">
                                                Main Image:{" "}
                                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("Please upload an image in 1219px width × 457px height")}</Tooltip>}>
                                                    <span className="field-more-info mt-1 ms-1 cp"> ? </span>
                                                </Whisper>
                                                <small className="text-muted d-block mt-1 ms-2">
                                                    Please upload an image in{" "}
                                                    ({" "}
                                                    <code>
                                                        {1219}px width × {457}px height
                                                    </code>
                                                    ).
                                                </small>
                                            </label>
                                            <input
                                                className="form-control imgInput"
                                                id="main_image"
                                                name="main_image"
                                                accept="image/*"
                                                type="file"
                                                onChange={(event) => {
                                                    formik.setFieldValue("main_image", event.target.files[0] || "");
                                                    event.target.files.length === 1 ? setPreviewImageMain(URL.createObjectURL(event.target.files[0])) : setPreviewImageMain("");
                                                }}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="main_image" form={formik} />
                                            </span>

                                            {previewImageMain ? (
                                                <ul className="question-image-preview questions-ul">
                                                    <li className="pr_img_box">
                                                        <img src={previewImageMain} style={{ height: "100px" }} alt={"Profile_Img"} />
                                                        <div className="img_options">
                                                            <button
                                                                type="button"
                                                                className="text-danger"
                                                                onClick={() => {
                                                                    // console.log(previewResImage , previewImageMain)
                                                                    setPreviewImageMain("");
                                                                    formik.setFieldValue("main_image", null);
                                                                    document.getElementById("main_image").value = "";
                                                                }}
                                                            >
                                                                <i className="ri-delete-bin-6-fill"></i>
                                                            </button>
                                                        </div>
                                                    </li>
                                                </ul>
                                            ) : (
                                                ""
                                            )}
                                        </div>

                                        {/* // Section 2  */}
                                        <hr></hr>
                                        <h3 className="mt-4">Section 2</h3>

                                        {/* ======= About Us ======== */}

                                        <h5 className="mt-4">About Us</h5>
                                        {formik?.values?.option?.map((option, index) => (
                                            <div key={index} className="row">
                                                <div className="col-md-6 text-center form-group">
                                                    <label htmlFor={`option_name_${index}`} className="text-left d-flex">
                                                        Option Name:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                        name={`option[${index}].option_title`}
                                                        id={`option_name_${index}`}
                                                        type="text"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={option.option_title}
                                                        className="form-control"
                                                        placeholder={t("Enter option name")}
                                                    />
                                                    {/* <span className="text-danger d-flex text-left">
                          <CustomError name={`option[${index}].option_title`} form={formik} />
                        </span> */}
                                                    {/* <span className='text-danger d-flex text-left'>{formik.errors.option[index].option_title && formik.touched.option[index].option_title && formik.errors.option[index].option_title}</span> */}
                                                </div>

                                                <div className="col-md-6 text-center form-group">
                                                    <label htmlFor={`option_content_${index}`} className="text-left d-flex">
                                                        Option Content:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                        name={`option[${index}].option_content`}
                                                        id={`option_content_${index}`}
                                                        type="text"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={option.option_content}
                                                        className="form-control"
                                                        placeholder={t("Enter option content")}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        <CustomError name={`option[${index}].option_content`} form={formik} />
                                                    </span>
                                                </div>

                                                {/* ====================Image section================ */}

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor={`option_image_${index}`} className="text-left d-flex">
                                                        {t("Image")}:
                                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("Please upload an image in 562px width × 351px height")}</Tooltip>}>
                                                            <span className="field-more-info mt-1 ms-1 cp"> ? </span>
                                                        </Whisper>
                                                        <small className="text-muted d-block mt-1 ms-2">
                                                        Please upload an image in{" "}
                                                        ({" "}
                                                        <code>
                                                            {562}px width × {351}px height
                                                        </code>
                                                        ).
                                                        </small>
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id={`option_image_${index}`}
                                                        name={`option[${index}].option_image`}
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => handleImageChange(event, index)}
                                                    />

                                                    {previewImages[index] && (
                                                        <ul className="question-image-preview questions-ul">
                                                            <li className="pr_img_box">
                                                                <img src={previewImages[index]} style={{ height: "100px" }} alt={`Profile_Img_${index}`} />
                                                                {/* <div className="img_options">
                                  <button
                                    type="button"
                                    className="text-danger"
                                    onClick={() => {
                                      setPreviewImages(prevState => {
                                        const updatedState = [...prevState];
                                        updatedState[index] = null;
                                        return updatedState;
                                      });
                                      formik.setFieldValue(`option[${index}].option_image`, null);
                                      document.getElementById(`option_image_${index}`).value = "";
                                    }}
                                  >
                                    <i className="ri-delete-bin-6-fill"></i>
                                  </button>
                                </div> */}
                                                            </li>
                                                        </ul>
                                                    )}
                                                </div>

                                                {/* ===============Image section end================= */}
                                                <div className="col-md-6 text-center form-group"></div>

                                                {/* Remove Option Button */}
                                                {index === formik.values.option?.length - 1 && (
                                                    <div className="col-md-1 mb-4 text-center align-content-center">
                                                        <button type="button" className="btn btn-danger" onClick={() => handleRemoveOption(index)}>
                                                            {t("Remove")}
                                                        </button>
                                                    </div>
                                                )}
                                                {/* Add Option Button */}
                                                {index === formik.values.option?.length - 1 && (
                                                    <div className="col-md-1 mb-4 text-center align-content-center">
                                                        <button type="button" className="btn btn-success w-100" onClick={handleAddOption}>
                                                            {t("Add")}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}

                                        <div className="mt-5">
                                            <button
                                                className="btn btn-info mr-2"
                                                type="submit"
                                                // disabled={submitted ? true : null}
                                            >
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                Submit
                                            </button>
                                            <button
                                                className="btn ripple btn-secondary"
                                                type="button"
                                                // disabled={submitted ? true : null}
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default AboutUsAdd;
